module.exports = __webpack_public_path__ + "img/Girl_010036.c748a655.png";